import { SITEGLUE_COLORS } from "~/lib/siteglue/marketing-chrome";
import { siteGlueMarketingChannelLabels } from "~/lib/siteglue/communication-channels";

export const TRISH_AVATAR = "/marketing/trish-onboarding-agent.png";

export const TRISH_SIGNATURE = {
  agentName: "Trish",
  agentTitle: "SiteGlue Onboarding Agent",
  companyName: "SiteGlue",
  avatarSrc: TRISH_AVATAR,
  accentColor: SITEGLUE_COLORS.green,
  phoneDisplay: "(720) 443-2710",
  emailAddress: "trish@siteglue.ai",
  websiteDisplay: "www.siteglue.ai",
} as const;

/** Online Support Specialist — Victoria (website concierge) between Trish and Jim. */
export const SITEGLUE_VICTORIA_AVAILABILITY = {
  name: "Victoria",
  title: "Online Support Specialist",
  avatarSrc: "/images/profiles/Victoria.png",
  status: "online" as const,
} as const;

/** Lead team member shown next to Trish in hire-builder availability. */
export const SITEGLUE_FOUNDER_AVAILABILITY = {
  name: "Jim Wanek",
  title: "SiteGlue AI Founder",
  avatarSrc: "/siteglue/jim-wanek.png",
  /** Founder handoff is invitation-only; default UI shows Unavailable. */
  status: "unavailable" as const,
} as const;

/** Prefill when Jim’s card routes the visitor to Victoria chat. */
export const JIM_TO_VICTORIA_ONBOARDING_MESSAGE =
  "I need help with onboarding my AI employee, can you take a message for Jim Wanek?" as const;

/** @deprecated Prefer siteGlueMarketingChannelLabels() from communication-channels. */
export const DEFAULT_OMNICHANNEL_LABELS = siteGlueMarketingChannelLabels();

